import { Dayjs } from 'dayjs';
import { TFunction } from 'i18next';

export const formatDateWithMonth = (date: Dayjs, t: TFunction, currentLanguage: string) => {
  const monthKey = date.format("MMMM").toLowerCase();
  const monthTranslation = t(`months.${monthKey}`, '');
  return `${date.format("DD ")}${monthTranslation || date.format("MMMM")}`;
}; 